import React from 'react';
import {defineMessages} from 'react-intl';
import type {
    FilterGroupNewFilter,
    FilterProps,
    FiltersProps,
    MultiKeyFilterTextValue,
    QueryFilterAdapterModel,
    QueryFilterAdapterProps,
} from '@igp/shared/components/filter';
import {FilterGroupNew, TextInputWithDropdownFilter, withQueryFilter} from '@igp/shared/components/filter';

import type {
    DebtResponsibleMasterAgentFilterName,
    DebtResponsibleMasterAgentFilterViewModel,
    DebtResponsibleMasterAgentQueryFilterKeys,
    DebtResponsibleMasterAgentTextFilterKeys,
} from '../types';

const localized = defineMessages({
    texyAgentUid: {
        id: 'AgentLevelReportV2Filters_textAgentUId',
        defaultMessage: 'Agent ID',
    },
});

type DebtResponsibleMasterAgentFiltersProps = FiltersProps<DebtResponsibleMasterAgentFilterViewModel, DebtResponsibleMasterAgentFilterName>;

function DebtResponsibleMasterAgentFilters({model, onChange, availableFilters}: DebtResponsibleMasterAgentFiltersProps) {
    const filters: FilterGroupNewFilter<DebtResponsibleMasterAgentFilterViewModel, DebtResponsibleMasterAgentFilterName>[] = [
        {
            filterName: 'agentUid',
            modelField: 'text',
            component: (props: FilterProps<MultiKeyFilterTextValue<DebtResponsibleMasterAgentTextFilterKeys>>) => (
                <TextInputWithDropdownFilter
                    options={[{label: localized.texyAgentUid, value: 'agent_uid'}]}
                    inputPlaceholder={localized.texyAgentUid}
                    width="full"
                    {...props}
                />
            ),
        },
    ];

    return (
        <FilterGroupNew
            mode="update-on-change"
            allFilters={filters}
            model={model}
            onChange={onChange}
            availableFilters={availableFilters}
        />
    );
}

type DebtResponsibleMasterAgentFiltersAdapterProps = QueryFilterAdapterProps<
    DebtResponsibleMasterAgentQueryFilterKeys,
    DebtResponsibleMasterAgentFilterName,
    DebtResponsibleMasterAgentTextFilterKeys
>;

function DebtResponsibleMasterAgentFiltersAdapter({model, onChange, ...props}: DebtResponsibleMasterAgentFiltersAdapterProps) {
    const filterModel: DebtResponsibleMasterAgentFilterViewModel = {
        text: model?.text ? {...model.text, option: model?.text?.option} : null,
    };

    function handleChange(model: DebtResponsibleMasterAgentFilterViewModel) {
        const result: QueryFilterAdapterModel<DebtResponsibleMasterAgentQueryFilterKeys, DebtResponsibleMasterAgentTextFilterKeys> = {
            text: model?.text ? {...model?.text, option: model?.text?.option} : undefined,
        };

        onChange(result);
    }

    return <DebtResponsibleMasterAgentFilters model={filterModel} onChange={handleChange} {...props} />;
}

export const DebtResponsibleMasterAgentQueryFilters = withQueryFilter<
    DebtResponsibleMasterAgentQueryFilterKeys,
    DebtResponsibleMasterAgentFilterName,
    DebtResponsibleMasterAgentTextFilterKeys
>(DebtResponsibleMasterAgentFiltersAdapter, {agentUid: ['agent_uid']});
